import { useListenFromRenderer } from "../message";

export function useListenReloadMessage() {
	useListenFromRenderer([
		{
			key: "reload",
			onMessage: () => {
				location.reload();
			},
		},
	]);
}
